<template>
  <div class="options">
    <div class="container">
      <div class="option-wrapper" v-for="option in options" :key="option.key">
        <button
          class="option"
          @click="$emit('selected', option)"
          :class="{ active: option.key === active }"
        >
          {{ option.label }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Options",
  props: ["options", "active"]
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.options {
  grid-area: options;
  padding: 1rem;
  height: 100%;
}

.container {
  height: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-row-gap: 0.5rem;
  grid-column-gap: 0.5rem;
}

.option-wrapper {
  display: flex;
}

.option {
  width: 100%;
  background: $black;
  border: 3px solid $gold;
  padding: 0.25rem 1rem;
  font: bold 1rem $courier;
  color: $gold;
  text-transform: uppercase;
  transition: all 0.3s ease-in-out;
}

.option:hover,
.option.active {
  cursor: pointer;
  background: $gold;
  color: $black;
}

@media screen and (max-width: 1024px) {
  .container {
    justify-content: space-between;
  }
}

@media screen and (max-width: 812px) {
  .options {
    padding: 0.5rem 0;
    overflow-y: scroll;
  }

  .option {
    margin: 0.5rem 0;
  }

  .option:first-of-type {
    margin-top: 0;
  }

  .option:last-of-type {
    margin-bottom: 0;
  }
}
</style>
